/* eslint-disable no-param-reassign */
'use strict';
define('rollNumber',['jquery'], function () {
	return function (format) {
		return {
			nextItem: false,
			current: false,
			bidFormat: format,
			frames: 125, // max amount of iterations in half a second due to setTimeout min cap of 4ms
			_timeout: null,
			cancel: function () {
				if (this._timeout) {
					clearTimeout(this._timeout);
					this._timeout = null;
				}

				if (this.current) {
					if (typeof this.current.sound !== 'undefined') {
						this.current.sound.stop();
					}

					this.current.where.removeClass('rolling');
				}

				this.current = false;
				this.nextItem = false;
			},
			addToQueue: function (where, from, to, sound) {
				var increment = (to - from || 0) / this.frames,
					// Add to queue
					item = {
						where: where,
						from: from || 0,
						to: to,
						increment: increment,
						sound: sound
					};

				if (!from) {
					from = 0;
				}

				if (!this.current) {
					this.current = item;
					where.addClass('rolling');

					if (typeof sound !== 'undefined') {
						sound.play();
					}

					this.processItem(where, from, to, increment, 0);
					return;
				}

				this.nextItem = item;
			},
			removeItem: function () {
				if (typeof this.current.sound !== 'undefined') {
					this.current.sound.stop();
				}

				this.current = this.nextItem;
				this.nextItem = false;

				if (this.current) {
					this.processItem(this.current.where, this.current.from, this.current.to,
						this.current.increment, 0);
				}
			},
			processItem: function (where, from, to, increment, iteration) {
				var target;

				from += increment;
				iteration++;

				if (iteration < this.frames) {
					target = this.bidFormat(from);
					this._timeout = setTimeout(this.processItem.bind(this), 0, where, from, to, increment, iteration);
				} else {
					target = this.bidFormat(to);
					where.removeClass('rolling');
					this.removeItem();
				}

				where.html(target).attr('data-size', determineSize(target));
			}
		};
	};

	function determineSize(no) {
		var number = no.replace(/\D+/g, ''), // remove non digits
			length = number.length,
			size = 'small';

		if (length > 6) {
			size = 'large';
		} else if (length > 5) {
			size = 'medium';
		}

		return size;
	}
});

